module.exports = __webpack_public_path__ + "static/media/logo-BB.1ef31ba0.jpg";